<template>
    <form class="item-editor-form">
        <fg-input v-model="item.id" :label="$t('season.id')" :disabled="action == 'edit'"></fg-input>
        <fg-input v-model="item.explanation" :label="$t('season.explanation')"></fg-input>
 
        <b-form-group :label="$t('season.start_time')" :label-for="generateId(2)">
            <b-form-datepicker :id="generateId(2)" v-model="item.startTime" class="mb-2" :placeholder="this.$t('datepicker.labelNoDateSelected')"
            :locale="this.$t('datepicker.locale')"></b-form-datepicker>
        </b-form-group>

        <b-form-group :label="$t('season.end_time')" :label-for="generateId(3)">
            <b-form-datepicker :id="generateId(3)" v-model="item.endTime" class="mb-2" :placeholder="this.$t('datepicker.labelNoDateSelected')" 
            :locale="this.$t('datepicker.locale')"></b-form-datepicker>
        </b-form-group>
        <FormButtons
            @submit="submit"
            :submit="$UIPrivilegeU('timetables/seasons')"   
            :reset="false" 
            :remove="action == 'item' && $UIPrivilegeD('timetables/seasons')" 
            :itemid="item.explanation"
            @remove="remove">
        </FormButtons>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />

    </form> 	
</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'

export default {
    components: { FormButtons },
    props: {
        item: { default: {} },
        action: { default: "new" }
    },
    data () {
        return {
            fields: [
                { key: "id", label: "",
                },
                { key: "explanation", label: "" },
            ],
            ok: false,
            error: false,
            loading: false,
            infoType: "save",
            showErrors: true
        }
    },
    methods: {
        submit(event) {
            if( event ) 
                event.preventDefault();

            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;

            setTimeout(() => { 
                this.$store.dispatch('timetable/updateSeason' , this.item).then(response => {
                    this.ok = response.data.errorCode === 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    //this.$emit('updateItem', this.item);
                })
            }, 1000);
        },
        reset(event){
            event.preventDefault();  
        },
        remove() {
            this.infoType = "delete";
            this.loading = true;

            setTimeout(() => { 
                this.$store.dispatch('timetable/deleteSeason' , this.item.id).then(response => {
                    this.ok = response.data.errorCode === 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        },
        generateId: function(iidee) {
            return "Id-" + iidee;
        }
  }
}
</script>

